import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import {
    withStyles,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    FormControlLabel,
    Switch,
    OutlinedInput,
    FormGroup,
    Divider,
} from '@material-ui/core';
import historyService from '../../services/historyLocalStorageService';
import translationPropType from '../../proptypes/translationPropType';
import { setUserDarkMode, setUserLanguage } from '../../reduxStore/config/user';
import { closeSettings } from '../../reduxStore/config/ui';

const styles = theme => ({
    form: {
        paddingTop: theme.spacing(1),
    },
    divider: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    forcedLabelBackground: {
        background: theme.palette.background.paper,
        padding: '0 2px',
    },
});

const Settings = ({
    classes,
    translation,
}) => {
    const [historyCleared, setHistoryCleared] = useState(false);

    const handleClearHistory = () => {
        historyService.clearHistory();
        setHistoryCleared(true);
    };

    const open = useSelector(state => state.ui.settingsOpen);

    const userDarkMode = useSelector(state => state.user.darkMode);

    const userPreferedLanguage = useSelector(state => state.user.preferedLanguage);

    const dispatch = useDispatch();

    const handleLanguageChange = (event) => {
        dispatch(setUserLanguage(event.target.value));
    };

    const handleDarkMode = (event) => {
        dispatch(setUserDarkMode(event.target.checked));
    };

    const handleClose = () => {
        dispatch(closeSettings);
    };

    return (
        <Dialog open={open} fullWidth onClose={handleClose} aria-labelledby="form-dialog-title">
            <DialogTitle id="form-dialog-title">{translation.SETTINGS}</DialogTitle>
            <DialogContent>
                <form className={classes.form} noValidate>
                    <FormGroup
                        row
                    >
                        <FormControl
                            fullWidth
                            variant="outlined"
                            margin="normal"
                        >
                            <InputLabel htmlFor="language-select" className={classes.forcedLabelBackground}>
                                {translation.LANGUAGE}
                            </InputLabel>
                            <Select
                                value={userPreferedLanguage}
                                onChange={handleLanguageChange}
                                input={
                                    <OutlinedInput labelWidth={0} name="language" id="language-select" />
                                }
                            >
                                <MenuItem value="sv-se">{translation.SWEDISH}</MenuItem>
                                <MenuItem value="en">{translation.ENGLISH}</MenuItem>
                            </Select>
                        </FormControl>
                    </FormGroup>
                    <Divider className={classes.divider} />
                    <FormGroup
                        row
                    >
                        <FormControl
                            fullWidth
                            className={classes.formControl}
                            margin="dense"
                        >
                            <FormControlLabel
                                control={(
                                    <Switch
                                        checked={userDarkMode}
                                        color="primary"
                                        onChange={handleDarkMode}
                                        value={userDarkMode}
                                    />
                                )}
                                label="Dark mode"
                            />
                        </FormControl>
                    </FormGroup>
                    <Divider className={classes.divider} />
                    <FormGroup
                        row
                    >
                        <FormControl
                            className={classes.formControl}
                            margin="normal"
                        >
                            <Button
                                onClick={handleClearHistory}
                                disabled={historyCleared}
                                color="primary"
                            >
                                {historyCleared
                                    ? translation.HISTORY_CLEARED
                                    : translation.CLEAR_SEARCH_HISTORY
                                }
                            </Button>
                        </FormControl>
                    </FormGroup>
                </form>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="primary">
                    {translation.CLOSE}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

Settings.propTypes = {
    classes: PropTypes.objectOf(PropTypes.any).isRequired,
    translation: translationPropType.isRequired,
};

export default withStyles(styles)(Settings);
